export default {"src":"/_next/static/media/pardugo.66cb5418.svg","height":230,"width":845};